<template>
  <div class="form-line" :class="{'-error': validations.find( o => o.condition )}">
    <fieldset :aria-describedby="validations.find( o => o.condition ) ? 'error-' + id : false">
      <legend v-if="legend" class="form-title">{{ legend }}</legend>
      <legend v-else class="a11y-sr-only">{{ name }}</legend>
      <ul class="radios" :class="{ '-inline' : inline }">
        <li class="radio" v-for="(radio, key) in options" :key="key">
          <input
            type="radio"
            :id="radio.id"
            :value="radio.value"
            :name="name"
            :checked="radio.value === value"
            @keyup.enter="$emit('click')"
            @click="$emit('click')"
            @blur="$emit('blur')"
            @change="$emit('change', radio.value)"
            :autocomplete="autocomplete"
            :disabled="disabled"
            :required="required ? true : false"
            :aria-required="required ? true : false"
            :aria-invalid="validations.find( o => o.condition ) ? true : false"
          >
          <label :for="radio.id">{{ radio.label }}</label>
        </li>
      </ul>
    </fieldset>
    <ValidationMessages v-if="validations" :validations="validations" :id="id" />
  </div>
</template>

<script>
import ValidationMessages from './ValidationMessages.vue'

export default {
  name: 'BaseRadiobutton',
  components: {
    ValidationMessages
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    id: {
      type: String,
      required: true
    },
    legend: {
      type: String,
      default: null,
      required: false
    },
    autocomplete: {
      type: String,
      required: false,
      default: null
    },
    inline: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    validations: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
